module.exports = {
    READY : 'ready',
    TODO : 'todo',
    FETCHING : 'fetching',
    FETCHED : 'fetched'
}